import { render, staticRenderFns } from "./dashboard-sale-low-rank.vue?vue&type=template&id=56333ccf&scoped=true&"
import script from "./dashboard-sale-low-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-sale-low-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-sale-low-rank.vue?vue&type=style&index=0&id=56333ccf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56333ccf",
  null
  
)

export default component.exports